import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../global/ui/Button";

import InputField from "../../global/ui/InputField";
import { getLocalStorage, showToast } from "../../utils";
import { apiConstants } from "../../utils/constants/apiConstants";
import { images } from "../../utils/constants/assets";

import {
  getURLstylistCode,
  isNotEmpty,
} from "../../utils/globalFunctions";
import {
  buildSelectedServiceEntry,
  findServiceInCategories,
} from "../../utils/shopifyBookingBootstrap";
import useStore from "../../zustandstore";

interface FeatureProps {
  handleNext: () => void;
  control?: any;
  errors?: any;
  watch?: any;
  handlePrevious: () => void;
  getValues?: any;
  setValue?: any;
  setStepNo?: any;
  setsignin?: any;
  // stylistlocationData?: any;
  totalAmountArr?: any;
  setTotalAmountArr?: any;
  stylistServicesData?: any;
  setStylistServicesData?: any;
  setPrevPage?: any;
  getResponse?: any;
  pendingServiceId?: string;
  shopifyAuthReady?: boolean;
}

interface _Item {
  id: number;
  name: string;

  amount: string;
  value: string;
  time: string;
}

export default function Features(props: FeatureProps) {
  const {
    control,
    _errors,
    handleNext,
    getResponse,
    watch,
    handlePrevious,
    getValues,
    setValue,
    setsignin,
    setStepNo,
    totalAmountArr,
    setTotalAmountArr,
    stylistServicesData,
    setStylistServicesData,
    setPrevPage,
    pendingServiceId = "",
    shopifyAuthReady = false,
  } = props;

  const setSelectedService = useStore((state: any) => state.setSelectedService);
  const selectedServices = useStore((state: any) => state.selectedServices);
  const unknownServiceNotifiedRef = useRef(false);

  useEffect(() => {
    getResponse();
    getaddress();
  }, []);

  useEffect(() => {
    if (!pendingServiceId || !stylistServicesData?.results?.service_categories?.length) {
      return;
    }
    if (selectedServices.some((item) => item?.serviceid === pendingServiceId)) {
      return;
    }

    const match = findServiceInCategories(
      stylistServicesData.results.service_categories,
      pendingServiceId
    );
    if (!match) {
      if (!unknownServiceNotifiedRef.current) {
        showToast(
          "We couldn't find that service. Please choose one below.",
          "info"
        );
        unknownServiceNotifiedRef.current = true;
      }
      return;
    }

    const updatedData = JSON.parse(JSON.stringify(stylistServicesData));
    updatedData.results.service_categories[match.categoryIndex].services_names[
      match.serviceIndex
    ].is_checked = true;
    setStylistServicesData(updatedData);

    const entry = buildSelectedServiceEntry(match.service);
    setSelectedService([entry]);
    setTotalAmountArr([entry]);
    setSelectedIndex(match.categoryIndex);
    if (setValue) {
      setValue(apiConstants.services, pendingServiceId);
    }
  }, [pendingServiceId, stylistServicesData, selectedServices, setSelectedService, setStylistServicesData, setTotalAmountArr, setValue]);

  const handleSubmit = () => {
    handleNext();
  };

  const [hasError, _setHasError] = useState(true);

  const [selectedIndex, setSelectedIndex] = useState<number | string>(0);

  const _signin = () => {
    setStepNo(4);
    setPrevPage(2);
    setsignin(true);
  };

  const mainstylistLocationData = useStore(
    (state: any) => state.stylistLocationData
  );

  const getaddress = () => {
    const selectedData = mainstylistLocationData?.results?.find((item) => {
      return item.id === getValues(apiConstants.location);
    });
    return selectedData;
  };

  const _radioValue = watch(apiConstants.services);

  const totalAmount = totalAmountArr.reduce(
    (amount, currentTotal) => amount + Number(currentTotal?.amount),
    0
  );

  /**
   * On change function that will set the states of
   * selected services of a stylist.
   */
  const onChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    catogoryIndex: number,
    serviceIndex: number
  ) => {
    const updatedData = stylistServicesData;

    const checkedOptions =
      updatedData.results.service_categories[catogoryIndex].services_names[
        serviceIndex
      ];

    const selecteddata = !checkedOptions?.is_checked;
    const serviceid = checkedOptions?.id;
    const amount = checkedOptions?.price;
    const name = checkedOptions?.name;
    const duration = checkedOptions?.duration;
    const hasProcessingTime = checkedOptions?.has_processing_time;

    const existingServiceIndex = selectedServices.findIndex(
      (item) => item?.serviceid === serviceid
    );

    if (existingServiceIndex !== -1) {
      // If the serviceid is already in the selectedService array, remove it
      const updatedpriceArr = [...selectedServices];
      updatedpriceArr.splice(existingServiceIndex, 1);

      // Arrange the sequence the remaining selected services.
      const arrangedServices = updatedpriceArr.map((service, index) => ({
        ...service,
        sequence_number: index + 1
      }));
      setTotalAmountArr(arrangedServices);
      setSelectedService(arrangedServices);
    } else {
      // If the serviceid is not in the selectedService array, add it
      const updatedpriceArr = [
        ...selectedServices,
        {
          serviceid,
          name,
          amount,
          duration,
          sequence_number: selectedServices.length + 1,
          ...(hasProcessingTime && {
            // Add the three if the service has processing time.
            has_processing_time: hasProcessingTime,
            processing_time: checkedOptions.processing_time,
            application_time: checkedOptions.application_time,
            finishing_time: checkedOptions.finishing_time
          })
        }
      ];
      setTotalAmountArr(updatedpriceArr);
      setSelectedService(updatedpriceArr);
    }

    // * modify this copy by finding the item with index of the item and toggle the existing value
    updatedData.results.service_categories[catogoryIndex].services_names[
      serviceIndex
    ].is_checked = selecteddata;

    // set this modified data to stylistdata
    setStylistServicesData(updatedData);
  };

  const [showWarningInfo, setShowWarningInfo] = useState(false);

  const handlePopClick = () => {
    setShowWarningInfo(!showWarningInfo);
  };

  const [totalPopUp, setTotalPopUp] = useState(false);

  const toggleVisibility = () => {
    setTotalPopUp(!totalPopUp);
  };

  // Check if service has description from API, fallback to mock if needed
  const getServiceWithDescription = (service) => {
    // If API provides description, use it
    if (service?.description) {
      return service;
    }
    
    // Otherwise, provide a fallback mock description for demo purposes
    const mockDescriptions = {
      'haircut': 'Professional haircut with styling and consultation',
      'color': 'Full hair coloring service with premium products',
      'highlights': 'Partial or full highlights to brighten your look',
      'blowout': 'Professional blowdry and styling for special occasions',
      'treatment': 'Deep conditioning treatment for healthy, shiny hair',
      'trim': 'Quick trim to maintain your current style',
      'wash': 'Professional hair wash and conditioning',
      'styling': 'Special event styling and finishing touches'
    };
    
    const serviceName = service?.name?.toLowerCase() || '';
    let description = '';
    
    Object.keys(mockDescriptions).forEach(keyword => {
      if (serviceName.includes(keyword)) {
        description = mockDescriptions[keyword];
      }
    });
    
    return {
      ...service,
      description: description || `Professional ${serviceName} service with expert styling`
    };
  };

  const getFormattedMblNumber = () => {
    let num = mainstylistLocationData?.stylist_info?.mobile_number?.slice(3);
    let countrycode =
      mainstylistLocationData?.stylist_info?.mobile_number?.slice(0, 3);

    if (num?.length === 9) {
      num = num?.slice(0, 3) + " " + num?.slice(3, 6) + " " + num?.slice(6);
    } else {
      num = num?.slice(0, 4) + " " + num?.slice(4, 7) + " " + num?.slice(7);
    }

    return countrycode + " " + num;
  };

  const access_token = shopifyAuthReady ? getLocalStorage("access_token") : null;

  const showInMapClicked = () => {
    window.open(
      "https://maps.google.com?q=" +
        getaddress()?.location[0] +
        "," +
        getaddress()?.location[1],
      "_blank"
    );
  };

  const setShowNav = useStore((state: any) => state.setShowNav);

  const navOpen = () => {
    setShowNav(true);
  };

  return (
    <div className="step_2">
      <div className="top_map">
        <img src={getaddress()?.location_image} alt="" />
      </div>
      <div className="upper-wrapper">
        <div className="go-back">
          <div onClick={handlePrevious}>
            <img src={images.go_back} alt="" />
          </div>

          {access_token ? (
            <div className="user-icon" onClick={navOpen}>
              <img src={images.user_1} alt="" />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="prsn-details-outer">
          <div className="prsn-img">
            <img
              src={
                mainstylistLocationData?.stylist_info?.business_logo || 
                mainstylistLocationData?.stylist_info?.profile_picture
              }
              alt=""
            />
          </div>

          <div className="prsn-details">
            <h1>
            {
              mainstylistLocationData?.stylist_info?.business_name ||
              mainstylistLocationData?.stylist_info?.full_name
            }
            </h1>
            {getValues(apiConstants.location) === "mbl_booking" ? (
              ""
            ) : (
              <p className="features-address">
                <img src={images.address_icn} alt="" />
                {/* {getValues(apiConstants.location) === "mbl_booking"
                ? getValues(apiConstants.custom_location)
                : getaddress()?.address} */}

                <span onClick={() => showInMapClicked()}>
                  {getaddress()?.address}
                </span>
              </p>
            )}

            {isNotEmpty(
              mainstylistLocationData?.stylist_info?.mobile_number
            ) && (
              <p className="ph-number">
                <img src={images.call_icn} alt="" />

                {/* {mainstylistLocationData?.stylist_info?.mobile_number} */}

                {getFormattedMblNumber()}
              </p>
            )}
          </div>
        </div>

        {getValues(apiConstants.location) === "mbl_booking" && (
          <div className="mbl-booking-box">
            <div className="icon">
              <img src={images.go_cart} alt="" />
            </div>

            <div>
              <p>{getValues(apiConstants.custom_location)}</p>
              <span>Mobile Booking</span>
            </div>
          </div>
        )}

        {access_token ? (
          ""
        ) : (
          <div className="before-here">
            <b onClick={handlePopClick}>
              <svg
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 -0.000976562C16.5237 -0.000976562 21.0015 4.47687 21.0015 10.0006C21.0015 15.5243 16.5237 20.0021 11 20.0021C5.47626 20.0021 0.998413 15.5243 0.998413 10.0006C0.998413 4.47687 5.47626 -0.000976562 11 -0.000976562ZM11 1.49902C6.30469 1.49902 2.49841 5.3053 2.49841 10.0006C2.49841 14.6959 6.30469 18.5021 11 18.5021C15.6952 18.5021 19.5015 14.6959 19.5015 10.0006C19.5015 5.3053 15.6952 1.49902 11 1.49902ZM10.9963 8.49961C11.376 8.49936 11.69 8.78131 11.7399 9.14735L11.7468 9.24911L11.7504 14.7507C11.7507 15.1649 11.4151 15.5009 11.0009 15.5012C10.6212 15.5014 10.3072 15.2195 10.2573 14.8535L10.2504 14.7517L10.2468 9.2501C10.2465 8.83588 10.5821 8.49988 10.9963 8.49961ZM11.0004 5.00184C11.552 5.00184 11.9991 5.44896 11.9991 6.0005C11.9991 6.55205 11.552 6.99917 11.0004 6.99917C10.4489 6.99917 10.0017 6.55205 10.0017 6.0005C10.0017 5.44896 10.4489 5.00184 11.0004 5.00184Z"
                  fill="#212121"
                />
              </svg>
              <div className="approx">
                <p>Sign in to view your booking details</p>
              </div>
            </b>

            <p>
              Been here before?
              <span>
                <Link
                  to={`/${getURLstylistCode()}/signin`}
                  // onClick={signin}
                >
                  Sign in
                </Link>
                {} to view your previously booked services.
              </span>
            </p>
          </div>
        )}

        {stylistServicesData?.results?.service_categories?.map(
          (category, index) => {
            return (
              <div
                className={`slide-toggle address-select-outer featured-outer Haircuts ${
                  selectedIndex === index ? "open" : ""
                }`}
                key={`category_${index}`}
              >
                <p
                  onClick={() => {
                    if (selectedIndex === index) {
                      setSelectedIndex("");
                    } else {
                      setSelectedIndex(index);
                    }
                  }}
                >
                  {category?.name}
                  <svg
                    width="16"
                    height="9"
                    viewBox="0 0 16 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L8 6.58579L14.2929 0.292893C14.6834 -0.0976311 15.3166 -0.0976311 15.7071 0.292893C16.0976 0.683417 16.0976 1.31658 15.7071 1.70711L8.70711 8.70711C8.31658 9.09763 7.68342 9.09763 7.29289 8.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                      fill="#212121"
                    />
                  </svg>
                </p>

                <div>
                  {category?.services_names?.map((service, serviceIndex) => {
                    const serviceWithDescription = getServiceWithDescription(service);
                    return (
                      <div key={service?.id}>
                        <div
                          className={
                            selectedServices.some((selectedService) => selectedService.serviceid === service?.id) ? "address active" : "address"
                          }
                        >
                          <InputField
                            key={service?.id}
                            name={apiConstants.services}
                            type="checkbox"
                            customOnChange={(event) => {
                              onChange(event, index, serviceIndex);
                              setValue(
                                apiConstants.services
                                // event.target.value
                              );
                            }}
                            control={control}
                            id={service?.id}
                          />
                          <div>
                            <span className="name">{serviceWithDescription?.name}</span>
                            {serviceWithDescription?.description && (
                              <p className="service-description">{serviceWithDescription?.description}</p>
                            )}
                            <div className="time-charge">
                              <p>
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM5.50153 3C5.74699 3 5.95114 3.17688 5.99347 3.41012L6.00153 3.5V6H7.5C7.77614 6 8 6.22386 8 6.5C8 6.74546 7.82312 6.94961 7.58988 6.99194L7.5 7H5.50153C5.25607 7 5.05192 6.82312 5.00958 6.58988L5.00153 6.5V3.5C5.00153 3.22386 5.22538 3 5.50153 3Z"
                                    fill="#2F2F2F"
                                  />
                                </svg>

                                <span>{service?.duration} minutes</span>
                              </p>
                              <p>
                                <svg
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9.61 5C9.85889 4.72618 9.99779 4.37003 10 4C10 3.60218 9.84196 3.22064 9.56066 2.93934C9.27936 2.65804 8.89782 2.5 8.5 2.5H5.91C5.98987 2.27409 6.01446 2.03233 5.98171 1.79496C5.94896 1.5576 5.85982 1.33153 5.72175 1.13569C5.58368 0.939852 5.40071 0.779939 5.18814 0.669339C4.97558 0.55874 4.73961 0.500673 4.5 0.5H1.5C1.10218 0.5 0.720644 0.658035 0.43934 0.93934C0.158035 1.22064 0 1.60218 0 2C0.00220531 2.37003 0.141105 2.72618 0.39 3C0.144023 3.27501 0.00803399 3.63103 0.00803399 4C0.00803399 4.36897 0.144023 4.72499 0.39 5C0.144023 5.27501 0.00803399 5.63103 0.00803399 6C0.00803399 6.36897 0.144023 6.72499 0.39 7C0.141105 7.27382 0.00220531 7.62997 0 8C0 8.39782 0.158035 8.77936 0.43934 9.06066C0.720644 9.34196 1.10218 9.5 1.5 9.5H8.5C8.78888 9.49846 9.07117 9.41353 9.31295 9.25542C9.55472 9.09731 9.7457 8.87275 9.86293 8.60872C9.98016 8.34469 10.0187 8.05243 9.97378 7.76705C9.92891 7.48167 9.80259 7.21532 9.61 7C9.85598 6.72499 9.99197 6.36897 9.99197 6C9.99197 5.63103 9.85598 5.27501 9.61 5ZM4.5 8.5H1.5C1.36739 8.5 1.24021 8.44732 1.14645 8.35355C1.05268 8.25979 1 8.13261 1 8C1 7.86739 1.05268 7.74021 1.14645 7.64645C1.24021 7.55268 1.36739 7.5 1.5 7.5H4.5C4.63261 7.5 4.75979 7.55268 4.85355 7.64645C4.94732 7.74021 5 7.86739 5 8C5 8.13261 4.94732 8.25979 4.85355 8.35355C4.75979 8.44732 4.63261 8.5 4.5 8.5ZM4.5 6.5H1.5C1.36739 6.5 1.24021 6.44732 1.14645 6.35355C1.05268 6.25979 1 6.13261 1 6C1 5.86739 1.05268 5.74021 1.14645 5.64645C1.24021 5.55268 1.36739 5.5 1.5 5.5H4.5C4.63261 5.5 4.75979 5.55268 4.85355 5.64645C4.94732 5.74021 5 5.86739 5 6C5 6.13261 4.94732 6.25979 4.85355 6.35355C4.75979 6.44732 4.63261 6.5 4.5 6.5ZM4.5 4.5H1.5C1.36739 4.5 1.24021 4.44732 1.14645 4.35355C1.05268 4.25979 1 4.13261 1 4C1 3.86739 1.05268 3.74021 1.14645 3.64645C1.24021 3.55268 1.36739 3.5 1.5 3.5H4.5C4.63261 3.5 4.75979 3.55268 4.85355 3.64645C4.94732 3.74021 5 3.86739 5 4C5 4.13261 4.94732 4.25979 4.85355 4.35355C4.75979 4.44732 4.63261 4.5 4.5 4.5ZM4.5 2.5H1.5C1.36739 2.5 1.24021 2.44732 1.14645 2.35355C1.05268 2.25979 1 2.13261 1 2C1 1.86739 1.05268 1.74021 1.14645 1.64645C1.24021 1.55268 1.36739 1.5 1.5 1.5H4.5C4.63261 1.5 4.75979 1.55268 4.85355 1.64645C4.94732 1.74021 5 1.86739 5 2C5 2.13261 4.94732 2.25979 4.85355 2.35355C4.75979 2.44732 4.63261 2.5 4.5 2.5ZM8.845 8.355C8.80068 8.40175 8.74712 8.43878 8.68773 8.46374C8.62834 8.4887 8.56441 8.50105 8.5 8.5H5.91C6.0299 8.17745 6.0299 7.82255 5.91 7.5H8.5C8.63261 7.5 8.75979 7.55268 8.85355 7.64645C8.94732 7.74021 9 7.86739 9 8C8.99908 8.06651 8.98489 8.13216 8.95827 8.19312C8.93166 8.25408 8.89315 8.30911 8.845 8.355V8.355ZM8.845 6.355C8.80068 6.40175 8.74712 6.43878 8.68773 6.46374C8.62834 6.4887 8.56441 6.50105 8.5 6.5H5.91C6.0299 6.17745 6.0299 5.82255 5.91 5.5H8.5C8.63261 5.5 8.75979 5.55268 8.85355 5.64645C8.94732 5.74021 9 5.86739 9 6C8.99908 6.06651 8.98489 6.13216 8.95827 6.19312C8.93166 6.25408 8.89315 6.30911 8.845 6.355V8.355ZM8.845 4.355C8.80068 4.40175 8.74712 4.43878 8.68773 4.46374C8.62834 4.4887 8.56441 4.50105 8.5 4.5H5.91C6.0299 4.17745 6.0299 3.82255 5.91 3.5H8.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4C8.99908 4.06651 8.98489 4.13216 8.95827 4.19312C8.93166 4.25408 8.89315 4.30911 8.845 4.355V8.355Z"
                                    fill="#2F2F2F"
                                  />
                                </svg>

                                <span>${service?.price} </span>
                              </p>
                            </div>
                          </div>

                          <div className="radio-btn-img"></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }
        )}
      </div>
      <div className="bottom-wrapper bottom-shadow">
        <div className="total">
          <div onClick={toggleVisibility}>
            <div className="total-pop">
              <svg
                width="28"
                height="28"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 11.5C7.58579 11.5 7.25 11.8358 7.25 12.25C7.25 12.6642 7.58579 13 8 13C8.41421 13 8.75 12.6642 8.75 12.25C8.75 11.8358 8.41421 11.5 8 11.5ZM8 3.5C6.61929 3.5 5.5 4.61929 5.5 6C5.5 6.27614 5.72386 6.5 6 6.5C6.27614 6.5 6.5 6.27614 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6C9.5 6.36931 9.36602 6.71582 9.13195 6.98447L9.02561 7.09468L8.90761 7.19439L8.66094 7.37874C8.53202 7.47988 8.41649 7.5832 8.30535 7.70162C7.79312 8.24747 7.5 8.98796 7.5 10C7.5 10.2761 7.72386 10.5 8 10.5C8.27614 10.5 8.5 10.2761 8.5 10C8.5 9.24223 8.69627 8.74641 9.03456 8.38592L9.11003 8.30994L9.19065 8.23718L9.27817 8.16553L9.49667 8.00243L9.6513 7.8771C10.1848 7.40774 10.5 6.72959 10.5 6C10.5 4.61929 9.38071 3.5 8 3.5Z"
                  fill="#2F2F2F"
                />
              </svg>

              {totalAmountArr.length === 0 ? null : (
                <div className="approx">
                  {totalAmountArr.map((total, index) => (
                    <div className="approx-inner" key={`total_${index}`}>
                      <div className="name">{total.name}</div>
                      <div className="amount">${total.amount}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            Approximate total
          </div>
          <span>${Number(totalAmount).toFixed(2)}</span>
        </div>

        <Button
          className={hasError ? "error continue-btn" : "continue-btn"}
          disabled={totalAmountArr.length > 0 ? false : true}
          type="submit"
          btnTxt={"Continue"}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}
